import styled from "styled-components";
import { Device } from "../../../../styles/screenSizes";
import { colors } from "../../../../styles/variables";

export const StyledLabel = styled.span`
  @media ${Device.mobile} {
    display: none;
  }
  margin-left: 5px;
  color: ${({ theme }) => theme.header?.shop?.navLinkColor || colors.white};
  font-size: 14px;
`;

export const StyledIconAndText = styled.span`
  display: flex;
  align-items: center;
  margin-left: 20px;
  cursor: pointer;
`;
